import React from 'react';
import vehicleDefaultImage from "../../../images/no-vehicle-picture.png";
import VehicleTypeDefaultIconByName from "../VehicleTypeDefaultIconByName/VehicleTypeDefaultIconByName";

const VehiclePicture = ({ className, url, vehicleType, height = 76, square = false, fit = "contain" }) => {
    const isStringHeight = typeof height === 'string';
    const isNumberHeight = typeof height === 'number';
    return (
        <>
            {vehicleType?.name && vehicleType?.name !== "Voiture" && !url ?
                <div style={{background: "#d7e0e5", color: "#b8c7d1", height: height}} className={"d-flex justify-content-center align-items-center bradius-5"}>
                    <VehicleTypeDefaultIconByName size={"2"} name={vehicleType?.default_icon_name} />
                </div>
            :
                <img
                    className={className}
                    style={{
                        width: '100%',
                        // If a numeric height is provided, keep the picture box consistent across cards.
                        height: isStringHeight ? height : (isNumberHeight ? height : undefined),
                        minHeight: isStringHeight ? undefined : (isNumberHeight ? undefined : height),
                        aspectRatio: square ? '1/1' : '',
                        objectFit: fit,
                        objectPosition: 'center',
                        backgroundColor: '#ffffff',
                        borderRadius: 5,
                        display: 'block',
                    }}
                    src={(url && url !== "" ) ? url : vehicleDefaultImage}
                    alt={"image"}
                />
            }
        </>
    );
};

export default VehiclePicture;
